
    import './styles.scoped.css';
    export default {
  "button-trigger": "awsui_button-trigger_l32fn_xo3sj_5"
};
  